const readRequiredEnv = (key) => {
  const value = process.env[key] || "";
  if (!value && process.env.NODE_ENV !== "test") {
    console.error(`[Config] Missing required environment variable: ${key}`);
  }
  return value;
};

export const isDevelopment = process.env.NODE_ENV === "development";
export const isProduction = process.env.NODE_ENV === "production";

export const API_BASE_URL = readRequiredEnv("REACT_APP_AWS_USER_ENDPOINT");
/**
 *  export const API_BASE_URL = readRequiredEnv("REACT_APP_AWS_USER_ENDPOINT");
    export const AWS_REGION = readRequiredEnv("REACT_APP_AWS_REGION");
    export const AWS_USER_POOL_ID = readRequiredEnv("REACT_APP_AWS_USER_POOL_ID");
    export const AWS_USER_POOL_WEB_CLIENT_ID = readRequiredEnv(
    "REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID",
    );
 * 
 */